import { render, staticRenderFns } from "./Completions.vue?vue&type=template&id=40222474"
import script from "./Completions.vue?vue&type=script&lang=js"
export * from "./Completions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports